import RepoItem from './repo-item';

export default RepoItem;
